import { BaseRepository } from '../../../infra/base.repository'
import { ConfigService } from '../../../infra/config'
import type { ProductOpenUnit } from './product-open-unit'

// endpoint base é open-unit (upsert/list de frascos abertos/fechados); log de consumo é um sub-recurso
// irmão do mesmo controller (product-consumption), acessado pelos métodos customizados abaixo.
export class ProductConsumptionRepository extends BaseRepository<ProductOpenUnit> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/product-consumption/open-unit', token, cache)
    }

    async closeUnit(productOpenUnitId: string) {
        const { json, statusCode, message } = await this.request.patch(
            this.config.posApiUrl + '/product-consumption/open-unit/' + productOpenUnitId + '/close/?token=' + this.resolvedToken,
            {},
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async reopenUnit(productOpenUnitId: string) {
        const { json, statusCode, message } = await this.request.patch(
            this.config.posApiUrl + '/product-consumption/open-unit/' + productOpenUnitId + '/reopen/?token=' + this.resolvedToken,
            {},
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    // estorna a baixa da abertura (a unidade volta ao estoque) e anula o frasco — só sem consumo declarado
    async voidOpening(productOpenUnitId: string) {
        const { json, statusCode, message } = await this.request.patch(
            this.config.posApiUrl + '/product-consumption/open-unit/' + productOpenUnitId + '/void/?token=' + this.resolvedToken,
            {},
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async estimateRemaining(productOpenUnitId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.posApiUrl + '/product-consumption/open-unit/' + productOpenUnitId + '/estimate/?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async findLogs(params: { serviceId?: string; appointmentId?: string; from?: Date; to?: Date } = {}) {
        let queryString = '?'
        for (const key in params) {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') queryString += key + '=' + params[key] + '&'
        }
        const url = this.config.posApiUrl + '/product-consumption/log/' + queryString + 'token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async sumLoggedForUnits(productOpenUnitIds: string[]): Promise<{ productOpenUnitId: string; logged: number }[]> {
        if (productOpenUnitIds.length === 0) return []
        const url = this.config.posApiUrl + '/product-consumption/open-unit/logged-sum/?ids=' + productOpenUnitIds.join(',') + '&token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
